const root = document.querySelector(".horizontal-scroll-story");
const story = root.querySelector(".story");
const track = root.querySelector(".track");
const desktopQuery = window.matchMedia("(min-width: 901px)");
let maxHorizontalMove = 0;
let currentHorizontalMove = 0;
let targetHorizontalMove = 0;
let scrollFrame = null;

// Horizontal scroll on vertical scroll
function updateStoryHeight() {
  if (!desktopQuery.matches) {
    story.style.height = "";
    track.style.transform = "";
    currentHorizontalMove = 0;
    targetHorizontalMove = 0;
    if (scrollFrame) {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = null;
    }
    return;
  }

  maxHorizontalMove = Math.max(track.scrollWidth - window.innerWidth, 0);
  story.style.height = `${maxHorizontalMove + window.innerHeight}px`;
  updateHorizontalScroll();
}

function updateHorizontalScroll() {
  if (!desktopQuery.matches) return;

  const rect = story.getBoundingClientRect();
  const total = story.offsetHeight - window.innerHeight;
  const progress = total > 0 ? Math.min(Math.max((-rect.top) / total, 0), 1) : 0;
  targetHorizontalMove = maxHorizontalMove * progress;

  if (!scrollFrame) {
    scrollFrame = window.requestAnimationFrame(renderSmoothScroll);
  }
}

function renderSmoothScroll() {
  const distance = targetHorizontalMove - currentHorizontalMove;

  currentHorizontalMove += distance * 0.08;

  if (Math.abs(distance) < 0.5) {
    currentHorizontalMove = targetHorizontalMove;
    scrollFrame = null;
  } else {
    scrollFrame = window.requestAnimationFrame(renderSmoothScroll);
  }

  track.style.transform = `translateX(-${currentHorizontalMove}px)`;
}

function requestHorizontalScrollUpdate() {
  updateHorizontalScroll();
}

window.addEventListener("scroll", requestHorizontalScrollUpdate, { passive: true });
window.addEventListener("resize", updateStoryHeight);
window.addEventListener("load", updateStoryHeight);
desktopQuery.addEventListener("change", updateStoryHeight);

if (document.fonts) {
  document.fonts.ready.then(updateStoryHeight);
}

updateStoryHeight();

// Memory board click interaction
const board = root.querySelector("#memoryBoard");
const counter = root.querySelector("#memoryCounter");

if (board) {
  const cards = board.querySelectorAll(".memory-card");
  let current = 0;
  let isChanging = false;

  board.addEventListener("click", () => {
    if (isChanging) return;

    isChanging = true;

    const previousCard = cards[current];
    previousCard.classList.add("leaving");
    previousCard.classList.remove("active");

    current = (current + 1) % cards.length;
    const currentCard = cards[current];
    currentCard.classList.add("active", "entering");

    counter.textContent = `${String(current + 1).padStart(2, "0")} / ${String(cards.length).padStart(2, "0")}`;

    window.setTimeout(() => {
      previousCard.classList.remove("leaving");
      currentCard.classList.remove("entering");
      isChanging = false;
    }, 900);
  });
}

// Friends board auto-cycling collage
const friendsBoard = root.querySelector("#friendsBoard");

if (friendsBoard) {
  const friendsCards = friendsBoard.querySelectorAll(".friends-card");
  let friendsIndex = 0;
  let highlightCard = 0;
  let friendsTimer = null;

  function showFriendsCard(index) {
    friendsCards.forEach(c => c.classList.remove("active"));
    friendsCards[index].classList.add("active");
  }

  function advanceFriends() {
    friendsIndex = (friendsIndex + 1) % friendsCards.length;
    showFriendsCard(friendsIndex);

    if (friendsIndex === highlightCard) {
      friendsTimer = setTimeout(advanceFriends, 2000);
      highlightCard = (highlightCard + 2) % friendsCards.length;
    } else {
      friendsTimer = setTimeout(advanceFriends, 700);
    }
  }

  friendsTimer = setTimeout(advanceFriends, 700);
}

// Auto-play video on scroll into view
const video = root.querySelector(".reel-panel video");

if (video) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        video.play();
      } else {
        video.pause();
      }
    },
    { threshold: 0.5 }
  );
  observer.observe(video);
}

// FAQ accordion
root.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const answer = item.querySelector('.faq-answer');
    const isOpen = btn.getAttribute('aria-expanded') === 'true';

    root.querySelectorAll('.faq-item.is-open').forEach(other => {
      if (other !== item) {
        other.classList.remove('is-open');
        other.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        other.querySelector('.faq-answer').style.display = 'none';
      }
    });

    item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', !isOpen);
    answer.style.display = isOpen ? 'none' : 'block';
  });
});
